export const UseRegistration = async (userObj: any) => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/signup_user_web`, {
				method: 'POST',
				headers: {'Content-Type': 'application/json'},
				credentials: 'include',
				body: JSON.stringify({
					name: userObj.name,
					email: userObj.email,
					phoneNr: userObj.phone,
					password: userObj.password
				})
		});
		let result = null;
		const status = response.status;
		if (status === 201) {
			result = await response.json();
		}
		return { result, status };
	} catch (e) {
		console.log(e);
	}
}

export const UseLogin = async (userObj: any) => {
	try {
		if (userObj.email && userObj.password) {
			console.log("userObj: ", userObj.email, userObj.password);
			const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/signin_user_web`, {
				method: 'POST',
				headers: {'Content-Type': 'application/json'},
				body: JSON.stringify({
					email: userObj.email.toLowerCase(),
					password: userObj.password,
					lng: userObj.language
				}),
				credentials: 'include'
			});
			let result = null;
			const status = response.status;
			if (status === 200) {
				result = await response.json();
			}
			return { result, status };
		}
	} catch (e) {
		console.log(e);
	}
}

export const UseAuth = async (lng: string) => {
	try {
		console.log("env: ", process.env.REACT_APP_API_URL);
		const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/auth_user_web/${lng}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
			credentials: 'include',
			// mode: 'no-cors'
			// credentials: 'include',
			// mode: 'no-cors'
		});

		let result = null;
		const status = response.status;
		if (status === 200) {
			result = await response.json();
		}
		return { result, status };
	} catch (e) {
		console.log(e);
	}
}

export const UseLogout = async () => {
	try {
		const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/logout_user_web`, {
			method: 'GET',
			headers: {'Content-Type': 'application/json'},
			credentials: 'include',
		});
		return response.status;
	} catch (e) {
		console.log(e);
	}
}